import { render, staticRenderFns } from "./withdrawalDetail.vue?vue&type=template&id=0fbcfeec&scoped=true&"
import script from "./withdrawalDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawalDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalDetail.vue?vue&type=style&index=0&id=0fbcfeec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbcfeec",
  null
  
)

export default component.exports